import { combineReducers } from 'redux';
import UserReducers from './user-reducers';
import CaseScheduleReducers from './case-schedule-reducers';
import SharedDataReducers from './shared-reducers';

const rootReducer = combineReducers({
  user: UserReducers,
  caseSchedule: CaseScheduleReducers,
  sharedData: SharedDataReducers
});

export default rootReducer;
